import {
  Component,
  Inject,
  NgZone,
  OnInit,
  ViewEncapsulation,
} from "@angular/core";
import * as moment from "moment";
import { NotifierService } from "../../shared/notifier/notifier.service";
import * as FileSaver from "file-saver";
import { DateAdapter, MAT_DIALOG_DATA, MatDialogRef } from "@angular/material";
import { PieceService } from "../../services/piece.service";
import { ClientService } from "../../services/client.service";

@Component({
  selector: "app-report-client-piece-dialog",
  templateUrl: "report-client-piece-dialog.component.html",
  styleUrls: ["./report-client-piece-dialog.component.scss"],
  encapsulation: ViewEncapsulation.None,
  providers: [PieceService, ClientService],
})
export class ReportClientPieceDialogComponent implements OnInit {
  fechaInicio: any;
  fechaFinal: any;
  clientId = 0;
  listClients = [];

  constructor(
    public dialogRef: MatDialogRef<ReportClientPieceDialogComponent>,
    private notifierService: NotifierService,
    private pieceService: PieceService,
    private clientService: ClientService,
    private zone: NgZone,
    @Inject(MAT_DIALOG_DATA) public injected: any,
    private dateAdapter: DateAdapter<Date>
  ) {
    this.dateAdapter.setLocale("es-PE");
  }

  ngOnInit() {
    this.clientService.getClientList().subscribe((listClients: any[]) => {
      this.listClients = listClients;
    });
  }

  generateReport() {
    if (!this.clientId) {
      this.notifierService.systemNotify({
        title: "Error",
        message: "Seleccione un cliente válido",
        type: "error",
      });
      return;
    }

    this.notifierService.systemNotify({
      title: "Descargando",
      message: "Descargando reporte de piezas",
      type: "info",
    });

    let fechaInicio: string | undefined = undefined;
    let fechaFinal: string | undefined = undefined;

    if (this.fechaInicio) {
      fechaInicio = moment(this.fechaInicio).format("YYYY-MM");
    }

    if (this.fechaFinal) {
      fechaFinal = moment(this.fechaFinal).format("YYYY-MM");
    }

    let params = undefined;
    if (fechaInicio || fechaFinal) {
      params = {
        fechaInicio,
        fechaFinal,
      };
    }

    this.pieceService
      .getExcelReportByClientAndParams(this.clientId, params)
      .subscribe(
        (result: any) => {
          let blob: any = result;
          let fileName = `report_piezas_${this.clientId}`;

          if (this.fechaInicio) {
            fileName += "_" + fechaInicio;
          }

          if (this.fechaFinal) {
            fileName += "_" + fechaFinal;
          }

          FileSaver.saveAs(blob, fileName);
          this.notifierService.systemNotify({
            title: "Descarga completada",
            message: "Reporte descargado correctamente",
            type: "success",
          });
        },
        (error) => {
          if (error.status == 404) {
            this.notifierService.systemNotify({
              title: "Error",
              message: "No se encontraron resultados para generar el reporte",
              type: "error",
            });
          } else {
            if (error.status == 400) {
              this.notifierService.systemNotify({
                title: "Error",
                message:
                  "Sucedió un error al generar el reporte utilizando los filtros",
                type: "error",
              });
            } else {
              this.notifierService.systemNotify({
                title: "Error",
                message: "Sucedió un error al descargar el reporte",
                type: "error",
              });
            }
          }
        }
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/system/work-order/report-client-piece-dialog/report-client-piece-dialog.component.ts